var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var Flex = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n"], ["\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n"])));
export { Flex };
var templateObject_1;
//# sourceMappingURL=Flex.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/Flex.js
// module id = 1058
// module chunks = 0